import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type {
  CashbackExperimentGroup,
  CashbackPromoSettings,
  CashbackState,
} from './types';

export const initialState: CashbackState = {
  data: null,
  promo: null,
  experimentGroup: 'default',
  experimentResolved: false,
  experimentAnalyticsSent: false,
};

const cashbackSlice = createSlice({
  name: 'cashback',
  initialState,
  reducers: {
    setCashbackData(state, action: PayloadAction<CashbackState['data']>) {
      state.data = action.payload;
    },
    setCashbackPromo(
      state,
      action: PayloadAction<CashbackPromoSettings | null>,
    ) {
      state.promo = action.payload;
    },
    setCashbackExperimentGroup(
      state,
      action: PayloadAction<CashbackExperimentGroup>,
    ) {
      state.experimentGroup = action.payload;
      state.experimentResolved = true;
    },
    setCashbackExperimentAnalyticsSent(state, action: PayloadAction<boolean>) {
      state.experimentAnalyticsSent = action.payload;
    },
  },
});

export const {
  setCashbackData,
  setCashbackPromo,
  setCashbackExperimentGroup,
  setCashbackExperimentAnalyticsSent,
} = cashbackSlice.actions;

export default cashbackSlice.reducer;
